import format from 'date-fns/format';

export const ALTERATION_REQUEST_SENT_FOR_ACCEPTANCE = 'ALTERATION_REQUEST_SENT_FOR_ACCEPTANCE';
export const ALTERATION_REQUEST_SENT_FOR_DECLINE = 'ALTERATION_REQUEST_SENT_FOR_DECLINE';

export const BOOKING_METHOD_AIRBNB = 'AIRBNB';

export const CANCELLATION_FEE_GROSS = 'GROSS';
export const CANCELLATION_FEE_NET = 'NET';

export const COMMISSION_CALCULATION_GROSS = 'GROSS';
export const COMMISSION_CALCULATION_NET = 'NET';
export const COMMISSION_CALCULATION_GROSS_LESS_CC = 'GROSS_LESS_CC';
export const COMMISSION_CALCULATION_NET_LESS_CC = 'NET_LESS_CC';
export const COMMISSION_CALCULATION_MAPPING = Object.freeze({
    [COMMISSION_CALCULATION_GROSS]: 'Gross',
    [COMMISSION_CALCULATION_NET]: 'Net',
    [COMMISSION_CALCULATION_GROSS_LESS_CC]: 'Gross less Channel Commission',
    [COMMISSION_CALCULATION_NET_LESS_CC]: 'Net less Channel Commission',
});
export const LIMITED_COMMISSION_CALCULATIONS = [
    COMMISSION_CALCULATION_GROSS, COMMISSION_CALCULATION_NET,
];
export const COMMISSION_CALCULATIONS = [
    COMMISSION_CALCULATION_GROSS, COMMISSION_CALCULATION_NET,
    COMMISSION_CALCULATION_GROSS_LESS_CC, COMMISSION_CALCULATION_NET_LESS_CC,
];

export const RESERVATION_STATUS_PAID = 'PAID'
export const RESERVATION_STATUS_PAIDDEPOSIT = 'PAIDDEPOSIT';
export const RESERVATION_STATUS_NOTPAID = 'NOTPAID';
export const RESERVATION_STATUS_CANCELLED = 'CANCELLED';
export const RESERVATION_STATUS_BLOCKED = 'BLOCKED';

export const DASHBOARD_CHART_INTERVAL_DAILY = 'DAILY';
export const DASHBOARD_CHART_INTERVAL_MONTHLY = 'MONTHLY';
export const DASHBOARD_CHART_INTERVAL_YEARLY = 'YEARLY';
export const DASHBOARD_CHART_INTERVAL_MAPPING = {
    [DASHBOARD_CHART_INTERVAL_DAILY]: 'Daily',
    [DASHBOARD_CHART_INTERVAL_MONTHLY]: 'Monthly',
    [DASHBOARD_CHART_INTERVAL_YEARLY]: 'Yearly',
}

export const DASHBOARD_CHART_MODULE_OWNERS = 'owners';
export const DASHBOARD_CHART_MODULE_QUICKBOOKS = 'quickbooks';
export const DASHBOARD_CHART_MODULE_MAPPING = {
    [DASHBOARD_CHART_MODULE_OWNERS]: 'Property Management',
    [DASHBOARD_CHART_MODULE_QUICKBOOKS]: 'QuickBooks',
}

export const DATE_PERIOD_YESTERDAY = 'YESTERDAY';
export const DATE_PERIOD_TODAY = 'TODAY';
export const DATE_PERIOD_TOMORROW = 'TOMORROW';
export const DATE_PERIOD_LAST_WEEK = 'LAST_WEEK';
export const DATE_PERIOD_THIS_WEEK = 'THIS_WEEK';
export const DATE_PERIOD_NEXT_WEEK = 'NEXT_WEEK';
export const DATE_PERIOD_THIS_YEAR = 'THIS_YEAR';
export const DATE_PERIOD_LAST_YEAR = 'LAST_YEAR';
export const DATE_PERIOD_THIS_MONTH = 'THIS_MONTH';
export const DATE_PERIOD_LAST_MONTH = 'LAST_MONTH';
export const DATE_PERIOD_FUTURE = 'FUTURE';
export const DATE_PERIOD_MAPPING = Object.freeze({
    [DATE_PERIOD_YESTERDAY]: 'Yesterday',
    [DATE_PERIOD_TODAY]: 'Today',
    [DATE_PERIOD_TOMORROW]: 'Tomorrow',
    [DATE_PERIOD_LAST_WEEK]: 'Last Week',
    [DATE_PERIOD_THIS_WEEK]: 'This Week',
    [DATE_PERIOD_NEXT_WEEK]: 'Next Week',
    [DATE_PERIOD_THIS_YEAR]: 'This Year',
    [DATE_PERIOD_LAST_YEAR]: 'Last Year',
    [DATE_PERIOD_THIS_MONTH]: 'This Month',
    [DATE_PERIOD_LAST_MONTH]: 'Last Month',
    [DATE_PERIOD_FUTURE]: 'All',
});

export const NEXTPAX_CHANNEL_AGO304 = 'AGO304';
export const NEXTPAX_CHANNEL_APA451 = 'APA451';
export const NEXTPAX_CHANNEL_BOO142 = 'BOO142';
export const NEXTPAX_CHANNEL_CTR342 = 'CTR342';
export const NEXTPAX_CHANNEL_EME322 = 'EME322';
export const NEXTPAX_CHANNEL_EXP270 = 'EXP270';
export const NEXTPAX_CHANNEL_FLO347 = 'FLO347';
export const NEXTPAX_CHANNEL_GOL390 = 'GOL390';
export const NEXTPAX_CHANNEL_GOO328 = 'GOO328';
export const NEXTPAX_CHANNEL_GOT374 = 'GOT374';
export const NEXTPAX_CHANNEL_HOL303 = 'HOL303';
export const NEXTPAX_CHANNEL_HTG276 = 'HTG276';
export const NEXTPAX_CHANNEL_HOP408 = 'HOP408';
export const NEXTPAX_CHANNEL_HYP370 = 'HYP370';
export const NEXTPAX_CHANNEL_MAR392 = 'MAR392';
export const NEXTPAX_CHANNEL_MON284 = 'MON284';
export const NEXTPAX_CHANNEL_MUC378 = 'MUC378';
export const NEXTPAX_CHANNEL_PLU366 = 'PLU366';
export const NEXTPAX_CHANNEL_ROO395 = 'ROO395';
export const NEXTPAX_CHANNEL_SKI286 = 'SKI286';
export const NEXTPAX_CHANNEL_URB386 = 'URB386';
export const NEXTPAX_CHANNEL_VAC394 = 'VAC394';
export const NEXTPAX_CHANNEL_WHI348 = 'WHI348';
export const NEXTPAX_CHANNEL_YON371 = 'YON371';
export const getNextpaxChannels = () => {
    const channels = [
        NEXTPAX_CHANNEL_BOO142,
        NEXTPAX_CHANNEL_EXP270,
        NEXTPAX_CHANNEL_AGO304,
        NEXTPAX_CHANNEL_APA451,
        NEXTPAX_CHANNEL_CTR342,
        NEXTPAX_CHANNEL_EME322,
        NEXTPAX_CHANNEL_FLO347,
        NEXTPAX_CHANNEL_GOL390,
        NEXTPAX_CHANNEL_GOO328,
        NEXTPAX_CHANNEL_GOT374,
        NEXTPAX_CHANNEL_HOL303,
        NEXTPAX_CHANNEL_HTG276,
        NEXTPAX_CHANNEL_HOP408,
        NEXTPAX_CHANNEL_HYP370,
        NEXTPAX_CHANNEL_MAR392,
        NEXTPAX_CHANNEL_MON284,
        NEXTPAX_CHANNEL_MUC378,
        NEXTPAX_CHANNEL_PLU366,
        NEXTPAX_CHANNEL_ROO395,
        NEXTPAX_CHANNEL_SKI286,
        NEXTPAX_CHANNEL_URB386,
        NEXTPAX_CHANNEL_VAC394,
        NEXTPAX_CHANNEL_WHI348,
        NEXTPAX_CHANNEL_YON371,
    ];
    return channels;
};

export const NEXTPAX_CHANNEL_MAPPING = Object.freeze({
    [NEXTPAX_CHANNEL_BOO142]: 'Booking.com',
    [NEXTPAX_CHANNEL_EXP270]: 'Expedia.com',
    [NEXTPAX_CHANNEL_AGO304]: 'Agoda',
    [NEXTPAX_CHANNEL_APA451]: 'OwnerDirect.com',
    [NEXTPAX_CHANNEL_CTR342]: 'Ctrip',
    [NEXTPAX_CHANNEL_EME322]: 'Emerald Coast By Owner',
    [NEXTPAX_CHANNEL_FLO347]: 'FloridaRentals',
    [NEXTPAX_CHANNEL_GOL390]: 'Golightly',
    [NEXTPAX_CHANNEL_GOO328]: 'Google VR',
    [NEXTPAX_CHANNEL_GOT374]: 'Got2Go',
    [NEXTPAX_CHANNEL_HOL303]: 'Holidu',
    [NEXTPAX_CHANNEL_HTG276]: 'HomeToGo',
    [NEXTPAX_CHANNEL_HOP408]: 'Hopper.com',
    [NEXTPAX_CHANNEL_HYP370]: 'HyperGuest',
    [NEXTPAX_CHANNEL_MAR392]: 'Marriott Homes & Villas',
    [NEXTPAX_CHANNEL_MON284]: 'NextTrip',
    [NEXTPAX_CHANNEL_MUC378]: 'Muchosol',
    [NEXTPAX_CHANNEL_PLU366]: 'Plum Guide',
    [NEXTPAX_CHANNEL_ROO395]: 'Rootrez',
    [NEXTPAX_CHANNEL_SKI286]: 'Ski.com',
    [NEXTPAX_CHANNEL_URB386]: 'Urbain Hospitality Group',
    [NEXTPAX_CHANNEL_VAC394]: 'VacayMyWay',
    [NEXTPAX_CHANNEL_WHI348]: 'Whimstay',
    [NEXTPAX_CHANNEL_YON371]: 'Yonder',
})

export const PARTNER_AIRBNB_CANCELLATION_POLICY_FLEXIBLE = 'flexible';
export const PARTNER_AIRBNB_CANCELLATION_POLICY_MODERATE = 'moderate';
export const PARTNER_AIRBNB_CANCELLATION_POLICY_STRICT_14_WITH_GRACE_PERIOD = 'strict_14_with_grace_period';
export const PARTNER_AIRBNB_CANCELLATION_POLICY_BETTER_STRICT_WITH_GRACE_PERIOD = 'better_strict_with_grace_period';
export const PARTNER_AIRBNB_CANCELLATION_POLICY_SUPER_STRICT_30 = 'super_strict_30';
export const PARTNER_AIRBNB_CANCELLATION_POLICY_SUPER_STRICT_60 = 'super_strict_60';
export const PARTNER_AIRBNB_CANCELLATION_POLICY_FIRM_14 = 'firm_14';
export const PARTNER_AIRBNB_CANCELLATION_POLICY_MAPPING = Object.freeze({
    [PARTNER_AIRBNB_CANCELLATION_POLICY_FLEXIBLE]: 'Flexible',
    [PARTNER_AIRBNB_CANCELLATION_POLICY_MODERATE]: 'Moderate',
    [PARTNER_AIRBNB_CANCELLATION_POLICY_STRICT_14_WITH_GRACE_PERIOD]: 'Strict (Grace Period)',
    [PARTNER_AIRBNB_CANCELLATION_POLICY_BETTER_STRICT_WITH_GRACE_PERIOD]: 'Firm (Grace Period)',
    [PARTNER_AIRBNB_CANCELLATION_POLICY_SUPER_STRICT_30]: 'Super Strict 30',
    [PARTNER_AIRBNB_CANCELLATION_POLICY_SUPER_STRICT_60]: 'Super Strict 60',
    [PARTNER_AIRBNB_CANCELLATION_POLICY_FIRM_14]: 'Limited',
});

export const PARTNER_AIRBNB_LONG_TERM_CANCELLATION_POLICY_CANCEL_LONG_TERM_FAIR = 'CANCEL_LONG_TERM_FAIR';
export const PARTNER_AIRBNB_LONG_TERM_CANCELLATION_POLICY_CANCEL_LONG_TERM_WITH_GRACE_PERIOD = 'CANCEL_LONG_TERM_WITH_GRACE_PERIOD';
export const PARTNER_AIRBNB_LONG_TERM_CANCELLATION_POLICY_MAPPING = Object.freeze({
    [PARTNER_AIRBNB_LONG_TERM_CANCELLATION_POLICY_CANCEL_LONG_TERM_FAIR]: 'Firm',
    [PARTNER_AIRBNB_LONG_TERM_CANCELLATION_POLICY_CANCEL_LONG_TERM_WITH_GRACE_PERIOD]: 'Strict',
});

export const PARTNER_AIRBNB_INSTANT_BOOKING_CATEGORY_EVERYONE = 'everyone';
export const PARTNER_AIRBNB_INSTANT_BOOKING_CATEGORY_EXPERIENCED = 'well_reviewed_guests';
export const PARTNER_AIRBNB_INSTANT_BOOKING_CATEGORY_OFF = 'off';
export const PARTNER_AIRBNB_INSTANT_BOOKING_CATEGORY_MAPPING = Object.freeze({
    [PARTNER_AIRBNB_INSTANT_BOOKING_CATEGORY_EVERYONE]: 'Everyone',
    [PARTNER_AIRBNB_INSTANT_BOOKING_CATEGORY_EXPERIENCED]: 'Experienced Guest',
    [PARTNER_AIRBNB_INSTANT_BOOKING_CATEGORY_OFF]: 'Off (Request to Book Only)',
});

export const PARTNER_AIRBNB_QUALITY_STANDARD_STATUS_WARN = 'WARN';
export const PARTNER_AIRBNB_QUALITY_STANDARD_STATUS_SUSPEND = 'SUSPEND';

export const PARTNER_AIRBNB_TAX_TYPE_PASS_THROUGH_HOTEL_TAX = 'pass_through_hotel_tax';
export const PARTNER_AIRBNB_TAX_TYPE_PASS_THROUGH_LODGING_TAX = 'pass_through_lodging_tax';
export const PARTNER_AIRBNB_TAX_TYPE_PASS_THROUGH_ROOM_TAX = 'pass_through_room_tax';
export const PARTNER_AIRBNB_TAX_TYPE_PASS_THROUGH_TOURIST_TAX = 'pass_through_tourist_tax';
export const PARTNER_AIRBNB_TAX_TYPE_PASS_THROUGH_TRANSIENT_OCCUPANCY_TAX = 'pass_through_transient_occupancy_tax';
export const PARTNER_AIRBNB_TAX_TYPE_PASS_THROUGH_SALES_TAX = 'pass_through_sales_tax';
export const PARTNER_AIRBNB_TAX_TYPE_PASS_THROUGH_VAT_GST = 'pass_through_vat_gst';
export const PARTNER_AIRBNB_TAX_TYPE_PASS_THROUGH_TOURISM_ASSESSMENT_FEE = 'pass_through_tourism_assessment_fee';
export const PARTNER_AIRBNB_TAX_TYPE_MAPPING = Object.freeze({
    [PARTNER_AIRBNB_TAX_TYPE_PASS_THROUGH_HOTEL_TAX]: 'Hotel tax',
    [PARTNER_AIRBNB_TAX_TYPE_PASS_THROUGH_LODGING_TAX]: 'Lodging tax',
    [PARTNER_AIRBNB_TAX_TYPE_PASS_THROUGH_ROOM_TAX]: 'Room tax',
    [PARTNER_AIRBNB_TAX_TYPE_PASS_THROUGH_TOURIST_TAX]: 'Tourist tax',
    [PARTNER_AIRBNB_TAX_TYPE_PASS_THROUGH_TRANSIENT_OCCUPANCY_TAX]: 'Transient occupancy tax',
    [PARTNER_AIRBNB_TAX_TYPE_PASS_THROUGH_SALES_TAX]: 'Sales tax',
    [PARTNER_AIRBNB_TAX_TYPE_PASS_THROUGH_VAT_GST]: 'VAT/GST',
    [PARTNER_AIRBNB_TAX_TYPE_PASS_THROUGH_TOURISM_ASSESSMENT_FEE]: 'Tourism Assessment/Fee',
});

export const PARTNER_AIRBNB_AMOUNT_TYPE_PERCENT_PER_RESERVATION = 'percent_per_reservation';
export const PARTNER_AIRBNB_AMOUNT_TYPE_FLAT_PER_GUEST = 'flat_per_guest';
export const PARTNER_AIRBNB_AMOUNT_TYPE_FLAT_PER_NIGHT = 'flat_per_night';
export const PARTNER_AIRBNB_AMOUNT_TYPE_FLAT_PER_GUEST_PER_NIGHT = 'flat_per_guest_per_night';
export const PARTNER_AIRBNB_AMOUNT_TYPE_MAPPING = Object.freeze({
    [PARTNER_AIRBNB_AMOUNT_TYPE_PERCENT_PER_RESERVATION]: 'Percent per booking',
    [PARTNER_AIRBNB_AMOUNT_TYPE_FLAT_PER_GUEST]: 'Fee per guest',
    [PARTNER_AIRBNB_AMOUNT_TYPE_FLAT_PER_NIGHT]: 'Fee per night',
    [PARTNER_AIRBNB_AMOUNT_TYPE_FLAT_PER_GUEST_PER_NIGHT]: 'Fee per guest, per night',
});

export const PARTNER_AIRBNB_TAXABLE_BASES_BASE_PRICE = 'base_price';
export const PARTNER_AIRBNB_TAXABLE_BASES_PASS_THROUGH_MANAGEMENT_FEE = 'pass_through_management_fee';
export const PARTNER_AIRBNB_TAXABLE_BASES_PASS_THROUGH_COMMUNITY_FEE = 'pass_through_community_fee';
export const PARTNER_AIRBNB_TAXABLE_BASES_PASS_THROUGH_LINEN_FEE = 'pass_through_linen_fee';
export const PARTNER_AIRBNB_TAXABLE_BASES_PASS_THROUGH_RESORT_FEE = 'pass_through_resort_fee';
export const PARTNER_AIRBNB_TAXABLE_BASES_PASS_THROUGH_CLEANING_FEE = 'pass_through_cleaning_fee';
export const PARTNER_AIRBNB_TAXABLE_BASES_PASS_THROUGH_PET_FEE = 'pass_through_pet_fee';
export const PARTNER_AIRBNB_TAXABLE_BASES_MAPPING = Object.freeze({
    [PARTNER_AIRBNB_TAXABLE_BASES_BASE_PRICE]: 'Base price',
    [PARTNER_AIRBNB_TAXABLE_BASES_PASS_THROUGH_MANAGEMENT_FEE]: 'Management fee',
    [PARTNER_AIRBNB_TAXABLE_BASES_PASS_THROUGH_COMMUNITY_FEE]: 'Community fee',
    [PARTNER_AIRBNB_TAXABLE_BASES_PASS_THROUGH_LINEN_FEE]: 'Linens fee',
    [PARTNER_AIRBNB_TAXABLE_BASES_PASS_THROUGH_RESORT_FEE]: 'Resort fee',
    [PARTNER_AIRBNB_TAXABLE_BASES_PASS_THROUGH_CLEANING_FEE]: 'Cleaning fee',
    [PARTNER_AIRBNB_TAXABLE_BASES_PASS_THROUGH_PET_FEE]: 'Pet fee',
});

export const PAYMENT_METHOD_CHECK = 1;
export const PAYMENT_METHOD_GIFT_CERTIFICATE = 2;
export const PAYMENT_METHOD_PAYPAL = 3;
export const PAYMENT_METHOD_CREDIT_CARD = 4;
export const PAYMENT_METHOD_BANK_TRANSFER = 5;
export const NO_PAYMENT_METHOD = 8;
export const PAYMENT_METHOD_E_CHECK = 9;
export const PAYMENT_METHOD_GUEST_CREDIT = 14;

export const PAYMENT_CARD_AMERICAN_EXPRESS = 'AMERICANEXPRESS';
export const PAYMENT_CARD_CARTES_BANCAIRES = 'CARTESBANCAIRES';
export const PAYMENT_CARD_DINERS_CLUB = 'DINERSCLUB';
export const PAYMENT_CARD_DISCOVER = 'DISCOVER';
export const PAYMENT_CARD_ELO = 'ELO';
export const PAYMENT_CARD_JCB = 'JCB';
export const PAYMENT_CARD_HIPERCARD = 'HIPERCARD';
export const PAYMENT_CARD_MAESTRO = 'MAESTRO';
export const PAYMENT_CARD_MASTERCARD = 'MASTERCARD';
export const PAYMENT_CARD_MIR = 'MIR';
export const PAYMENT_CARD_UNION_PAY = 'UNIONPAY';
export const PAYMENT_CARD_VISA = 'VISA';
export const PAYMENT_CARD_MAPPING = Object.freeze({
    [PAYMENT_CARD_AMERICAN_EXPRESS]: 'American Express',
    [PAYMENT_CARD_CARTES_BANCAIRES]: 'Cartes Bancaires',
    [PAYMENT_CARD_DINERS_CLUB]: 'Diners Club',
    [PAYMENT_CARD_DISCOVER]: 'Discover',
    [PAYMENT_CARD_ELO]: 'Elo',
    [PAYMENT_CARD_JCB]: 'Jcb',
    [PAYMENT_CARD_HIPERCARD]: 'Hipercard',
    [PAYMENT_CARD_MAESTRO]: 'Maestro',
    [PAYMENT_CARD_MASTERCARD]: 'Mastercard',
    [PAYMENT_CARD_MIR]: 'Mir',
    [PAYMENT_CARD_UNION_PAY]: 'UnionPay',
    [PAYMENT_CARD_VISA]: 'Visa',
});
export const convertFromBraintreeCardType = (cardType) => {
    return {
        'american-express': PAYMENT_CARD_AMERICAN_EXPRESS,
        'diners-club': PAYMENT_CARD_DINERS_CLUB,
        'discover': PAYMENT_CARD_DISCOVER,
        'elo': PAYMENT_CARD_ELO,
        'jcb': PAYMENT_CARD_JCB,
        'hiper': PAYMENT_CARD_HIPERCARD,
        'hipercard': PAYMENT_CARD_HIPERCARD,
        'maestro': PAYMENT_CARD_MAESTRO,
        'mastercard': PAYMENT_CARD_MASTERCARD,
        'mir': PAYMENT_CARD_MIR,
        'unionpay': PAYMENT_CARD_UNION_PAY,
        'visa': PAYMENT_CARD_VISA,
    }[cardType];
};
export const convertFromStripeCardType = (cardType) => {
    return {
        'amex': PAYMENT_CARD_AMERICAN_EXPRESS,
        'cartes_bancaires': PAYMENT_CARD_CARTES_BANCAIRES,
        'diners': PAYMENT_CARD_DINERS_CLUB,
        'discover': PAYMENT_CARD_DISCOVER,
        'jcb': PAYMENT_CARD_JCB,
        'mastercard': PAYMENT_CARD_MASTERCARD,
        'unionpay': PAYMENT_CARD_UNION_PAY,
        'visa': PAYMENT_CARD_VISA,
    }[cardType];
};

export const RECURRENCE_FREQ_YEARLY = 'YEARLY';
export const RECURRENCE_FREQ_MONTHLY = 'MONTHLY';
export const RECURRENCE_FREQ_WEEKLY = 'WEEKLY';
export const RECURRENCE_FREQ_DAILY = 'DAILY';

export const RECURRENCE_WEEKDAY_MONDAY = 'MO';
export const RECURRENCE_WEEKDAY_TUESDAY = 'TU';
export const RECURRENCE_WEEKDAY_WEDNESDAY = 'WE';
export const RECURRENCE_WEEKDAY_THURSDAY = 'TH';
export const RECURRENCE_WEEKDAY_FRIDAY = 'FR';
export const RECURRENCE_WEEKDAY_SATURDAY = 'SA';
export const RECURRENCE_WEEKDAY_SUNDAY = 'SU';
export const RECURRENCE_WEEKDAY_MAPPING = Object.freeze({
    [RECURRENCE_WEEKDAY_MONDAY]: 'M',
    [RECURRENCE_WEEKDAY_TUESDAY]: 'T',
    [RECURRENCE_WEEKDAY_WEDNESDAY]: 'W',
    [RECURRENCE_WEEKDAY_THURSDAY]: 'T',
    [RECURRENCE_WEEKDAY_FRIDAY]: 'F',
    [RECURRENCE_WEEKDAY_SATURDAY]: 'S',
    [RECURRENCE_WEEKDAY_SUNDAY]: 'S',
})

export const RECURRENCE_MONTH_JANUARY = 1;
export const RECURRENCE_MONTH_FEBRUARY = 2;
export const RECURRENCE_MONTH_MARCH = 3;
export const RECURRENCE_MONTH_APRIL = 4;
export const RECURRENCE_MONTH_MAY = 5;
export const RECURRENCE_MONTH_JUNE = 6;
export const RECURRENCE_MONTH_JULY = 7;
export const RECURRENCE_MONTH_AUGUST = 8;
export const RECURRENCE_MONTH_SEPTEMBER = 9;
export const RECURRENCE_MONTH_OCTOBER = 10;
export const RECURRENCE_MONTH_NOVEMBER = 11;
export const RECURRENCE_MONTH_DECEMBER = 12;
export const RECURRENCE_MONTH_MAPPING = Object.freeze({
    [RECURRENCE_MONTH_JANUARY]: 'January',
    [RECURRENCE_MONTH_FEBRUARY]: 'February',
    [RECURRENCE_MONTH_MARCH]: 'March',
    [RECURRENCE_MONTH_APRIL]: 'April',
    [RECURRENCE_MONTH_MAY]: 'May',
    [RECURRENCE_MONTH_JUNE]: 'June',
    [RECURRENCE_MONTH_JULY]: 'July',
    [RECURRENCE_MONTH_AUGUST]: 'August',
    [RECURRENCE_MONTH_SEPTEMBER]: 'September',
    [RECURRENCE_MONTH_OCTOBER]: 'October',
    [RECURRENCE_MONTH_NOVEMBER]: 'November',
    [RECURRENCE_MONTH_DECEMBER]: 'December',
})

export const REVIEW_STATUS_PENDING = 'pending';
export const REVIEW_STATUS_EXPIRES_SOON = 'expires_soon';
export const REVIEW_STATUS_SUBMITTED = 'submitted';
export const REVIEW_STATUS_EXPIRED = 'expired';
export const REVIEW_STATUS_MAPPING = Object.freeze({
    [REVIEW_STATUS_PENDING]: 'Pending',
    [REVIEW_STATUS_EXPIRES_SOON]: 'Expires Soon',
    [REVIEW_STATUS_SUBMITTED]: 'Submitted',
    [REVIEW_STATUS_EXPIRED]: 'Expired',
})

export const FILTERS_STORAGE_OWNER_LIST_ID = 'OWNER-LIST';
export const VENDOR = 'VENDOR';
export const OWNER = 'OWNER';
export const SUBSCRIBER = 'SUBSCRIBER';
export const TEAM_MEMBER = 'TEAM_MEMBER';
export const OTHER = 'OTHER';
export const ActorType = Object.freeze({
    Vendor: VENDOR,
    Owner: OWNER,
    Subscriber: SUBSCRIBER,
    TeamMember: TEAM_MEMBER,
    Other: OTHER,
});
export const CREATE = 'CREATE';
export const EDIT = 'EDIT';
export const WorkOrderActionType = Object.freeze({
    Create: CREATE,
    Edit: EDIT,
});
export const DEFAULT_WORK_ORDER = {
    id: '',
    number: null,
    status: '',
    rentalProperty: {
        id: '',
        other: '',
    },
    reporter: {
        type: '',
        value: '',
    },
    altReporter: '',
    accountAssignee: '',
    account: '',
    jobType: '',
    priority: '',
    dateReported: format(new Date(), 'yyyy-MM-dd'),
    description: '',
    startDate: '',
    completedDate: '',
    amount: 0,
    invoiceNumber: '',
    invoiceVendor: '',
    receiptNumber: '',
    receiptStore: '',
    assignee: {
        type: '',
        value: '',
    },
    notifier: {
        type: '',
        value: '',
    },
    emailDetails: true,
    notes: '',
    internalNotes: '',
    whoWillPay: '',
    photos: [],
    damage_notice_source: null,
};

export const PUBLIC_API_CHANGE_LOG_TAG_BLUE = 'BLUE'
export const PUBLIC_API_CHANGE_LOG_TAG_RED = 'RED'
export const PUBLIC_API_CHANGE_LOG_TAG_GRAY = 'GRAY'
export const PUBLIC_API_CHANGE_LOG_TAG_BADGE_COLOR_MAPPING = Object.freeze({
    [PUBLIC_API_CHANGE_LOG_TAG_BLUE]: 'primary',
    [PUBLIC_API_CHANGE_LOG_TAG_RED]: 'danger',
    [PUBLIC_API_CHANGE_LOG_TAG_GRAY]: 'dark',
})

export const SUBSCRIPTION_STATUS_TRIAL = 'Trial'
export const SUBSCRIPTION_STATUS_PENDING = 'Pending'
export const SUBSCRIPTION_STATUS_ACTIVE = 'Active'
export const SUBSCRIPTION_STATUS_SUSPENDED = 'Suspended'
export const SUBSCRIPTION_STATUS_GRACE_PERIOD = 'Grace Period'
export const SUBSCRIPTION_STATUS_CANCELLED = 'Cancelled'
export const SUBSCRIPTION_STATUS_TRIAL_PERIOD_EXPIRED = 'Trial Period Expired'
export const SUBSCRIPTION_STATUS_MAPPING = Object.freeze({
    'TRIAL': SUBSCRIPTION_STATUS_TRIAL,
    'PENDING': SUBSCRIPTION_STATUS_PENDING,
    'ACTIVE': SUBSCRIPTION_STATUS_ACTIVE,
    'SUSPENDED': SUBSCRIPTION_STATUS_SUSPENDED,
    'GRACE': SUBSCRIPTION_STATUS_GRACE_PERIOD,
    'CANCELLED': SUBSCRIPTION_STATUS_CANCELLED,
    'TRIALSUSPEND': SUBSCRIPTION_STATUS_TRIAL_PERIOD_EXPIRED,
})

export const VRBO_REGISTRATION_STATUS_COMPLIANT = 'COMPLIANT';
export const VRBO_REGISTRATION_STATUS_COMPLIANT_ACTION_NEEDED = 'COMPLIANT_ACTION_NEEDED';
export const VRBO_REGISTRATION_STATUS_NOT_COMPLIANT = 'NOT_COMPLIANT';
export const VRBO_REGISTRATION_STATUS_NOT_COMPLIANT_ACTION_NEEDED = 'NOT_COMPLIANT_ACTION_NEEDED';
export const VRBO_REGISTRATION_STATUS_NOT_ALLOWED = 'NOT_ALLOWED';
export const VRBO_REGISTRATION_STATUS_NONE = 'NONE';
export const VRBO_REGISTRATION_STATUS_MAPPING = Object.freeze({
    [VRBO_REGISTRATION_STATUS_COMPLIANT]: 'Compliant',
    [VRBO_REGISTRATION_STATUS_COMPLIANT_ACTION_NEEDED]: 'Compliant (action needed)',
    [VRBO_REGISTRATION_STATUS_NOT_COMPLIANT]: 'Not compliant',
    [VRBO_REGISTRATION_STATUS_NOT_COMPLIANT_ACTION_NEEDED]: 'Not compliant',
    [VRBO_REGISTRATION_STATUS_NOT_ALLOWED]: 'Not allowed',
    [VRBO_REGISTRATION_STATUS_NONE]: 'Cannot be determined',
});

export const SERVER_DATE_FORMAT = 'yyyy-MM-dd';
export const UNCOLLECTED_ALL = false;
export const UNCOLLECTED_UNCOLLECTED = true;
export const UNCOLLECTED = [UNCOLLECTED_ALL, UNCOLLECTED_UNCOLLECTED];
export const PAGE_ORIENTATION = ['landscape', 'portrait'];
export const PAGE_ORIENTATION_LABELS = ['Landscape', 'Portrait'];
export const TRANSACTION_TYPE = ['All', 'Payments', 'Refunds', 'Credits'];


export const BILL_TYPE_MAPPING = {
    0: 'Payment',
    1: 'Refund',
    2: 'Pre-Auth',
};

export const LODGIX_IMAGE_FILES_ALLOWED_EXTENSIONS = [
    '.png', '.jpg', '.jpeg', '.gif', '.bmp', '.webp', '.heic', '.heif',
];

export const NOTIFICATION_DROPDOWN_MAX = 10;

export const TRANSACTION_VARIANT_AUTOMATED_PAYMENT_PREDICTION = 'AUTOMATED_PAYMENT_PREDICTION'
export const TRANSACTION_VARIANT_AUTOMATED_PAYMENT_NOTIFICATION = 'AUTOMATED_PAYMENT_NOTIFICATION'

export const PAYMENT_METHOD_CONFIRMATION_STATUS_FAILED = 'FAILED'
export const PAYMENT_METHOD_CONFIRMATION_STATUS_PENDING = 'PENDING'
export const PAYMENT_METHOD_CONFIRMATION_STATUS_CONFIRMED = 'CONFIRMED'

